import type { AlpineComponent } from 'alpinejs';

export const progressBar = (): AlpineComponent => ({
	offsetLeft: 0,
	init() {
		this.offsetLeft = this.$refs['text-0'].offsetLeft;
	}
});
